import { USER_ENDPOINT } from './constants';

export const makeUserEndpoint = (id: string) => {
  return `/c/v1/users/${id}` as typeof USER_ENDPOINT;
};
